import { ToastController } from '@ionic/angular';
import { GlobalizationConfig } from '../interfaces/globalization-config.interface';
import { TranslationService } from '../services/translation.service';
import { QuestionTypeEnum, QuestionConfigTypeEnum, ValuesGlobalization } from '../interfaces/process-config.interface';
import { ProcessStatusEnum, ProcessTypeEnum } from '../interfaces/process.interface';
import { GoalStatusEnum } from 'src/app/goals/_interfaces/goal.interface';
import { isNil } from 'lodash';
import { errorTranslator } from "src/app/shared/utils/errorTranslation/errorTranslator";

export abstract class BaseClass {

    public GoalStatus = GoalStatusEnum;
    public ProcessStatus = ProcessStatusEnum;
    public ProcessType = ProcessTypeEnum;
    public QuestionType = QuestionTypeEnum;
    public QuestionConfigType = QuestionConfigTypeEnum;
    public selectedLanguage: string = this._translationService.getSelectedLanguage();

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService
    ) {
    }


    public getText(globalizationConfig: GlobalizationConfig, property: string): string {
        if (!globalizationConfig) return '';
        return this._translationService.getTranslationByConfig(
            globalizationConfig, property
        );
    }

    public getTextGlobalized(globalizationConfig: ValuesGlobalization, index: number): string {
        if (!globalizationConfig) return '';
        return this._translationService.getTranslation(
            globalizationConfig[this.selectedLanguage][index]
        );
    }

    public getSelectedLanguage(): string {
        return this._translationService.getSelectedLanguage()
    }

    public getImageUrl(imageUrl: string | null): string {
        return imageUrl ? imageUrl : './assets/imgs/user-image-placeholder.png';
    }

    public getParsedDescription(description: string): string {
        return description.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    protected readFromStorage(key: string): any | null {
        const storageStr = localStorage.getItem(key);
        return !!storageStr ? JSON.parse(storageStr) : null;
    }

    protected notifySuccess(messageKey: string = 'generic.saveSuccess') {
        this.notify(
            this._translationService.getTranslation(
                messageKey
            ), 'success'
        );
    }

    protected notifyError(error, frontendValidation = false, duration: number = 3000) {
        this.notify(
            frontendValidation ? error : this.getErrorNotification(error), 'danger', duration
        );
    }

    protected async notify(message: string, color: string = 'dark', duration?: number) {
        const toast = await this._toastController.create({
            message: message,
            position: 'top',
            color: color,
            duration: duration || 3000
        });
        await toast.present();
    }

    protected getErrorNotification(response): string {
        if (!response || !response.status)
            return this._translationService.getTranslation('generic.serverError');

        switch (response.status) {
            case 401:
                return this._translationService.getTranslation('generic.authenticationError');
            case 404:
                return this._translationService.getTranslation('generic.endpointNotFound');
            case 500:
                return this._translationService.getTranslation('generic.serverError');
            default:
                if (!isNil(response.error) && !isNil(response.error.errors) && response.error.errors.length > 0) {
                    const errorMessage = response.error.errors[0];
                    const translatedError = errorTranslator(errorMessage, this.selectedLanguage);

                    if (translatedError !== "") {
                        return translatedError;
                    }

                    return this._translationService.getTranslation(errorMessage);
                }
                if (!isNil(response.error) && response.error.length > 0) {
                    const errorMessage = response.error[0];
                    const translatedError = errorTranslator(errorMessage, this.selectedLanguage);

                    if (translatedError !== "") {
                        return translatedError;
                    }
                    return this._translationService.getTranslation(errorMessage);
                }
                if (!isNil(response.errors) && response.errors.length > 0) {
                    const errorMessage = response.errors[0];
                    const translatedError = errorTranslator(errorMessage, this.selectedLanguage);

                    if (translatedError !== "") {
                        return translatedError;
                    }
                    return this._translationService.getTranslation(errorMessage);
                }
                return this._translationService.getTranslation('generic.serverError');
        }
    }

    public getLocalDate(date: string) {
        if (date && date.length > 0) {
            let dateFormatted: Date = new Date(date);
            dateFormatted.setHours(dateFormatted.getHours() + 3);
            return dateFormatted;
        }
        return date;
    }
}
